export default {
  default: () => import("/app/layouts/default.vue"),
  error: () => import("/app/layouts/error.vue"),
  library: () => import("/app/layouts/library.vue")
}